import { LocalizationData, LocalizationPath } from '@tokyojob/core'
import { LocalizationService } from '@tokyojob/frontend-core'

/**
 * The titles for Vacancy Details Cards in the Vacancy Detail Page
 */
export class VacancyDetailCardTitle {
  public static ContractDetails(localization: LocalizationData) {
    return LocalizationService.t<string>(localization, LocalizationPath.ContractDetails)
  }
  public static WagesAndShifts(localization: LocalizationData) {
    return LocalizationService.t<string>(localization, LocalizationPath.WagesAndShifts)
  }
  public static RaisesAndBonuses(localization: LocalizationData) {
    return LocalizationService.t<string>(localization, LocalizationPath.RaisesAndBonuses)
  }
  public static SocialInsuranceAndBenefits(localization: LocalizationData) {
    return LocalizationService.t<string>(localization, LocalizationPath.InsuranceAndBenefits)
  }
  public static Benefits(localization: LocalizationData) {
    return LocalizationService.t<string>(localization, LocalizationPath.Benefits)
  }
  public static Allowances(localization: LocalizationData) {
    return LocalizationService.t<string>(localization, LocalizationPath.Allowances)
  }
  public static JapaneseLanguageSkills(localization: LocalizationData) {
    return LocalizationService.t<string>(localization, LocalizationPath.JapaneseSkills)
  }
  public static JapaneseBusinessSKills(localization: LocalizationData) {
    return LocalizationService.t<string>(localization, LocalizationPath.JapaneseBusinessSkills)
  }
  public static DesiredSkills(localization: LocalizationData) {
    return LocalizationService.t<string>(localization, LocalizationPath.DesiredSkills)
  }
  public static RequiredSkills(localization: LocalizationData) {
    return LocalizationService.t<string>(localization, LocalizationPath.RequiredSkills)
  }
  public static WorkplaceDetails(localization: LocalizationData) {
    return LocalizationService.t<string>(localization, LocalizationPath.WorkplaceDetails)
  }
}
